import { Dispatch } from "redux";
import { loadAndTrack } from "redux-request-loading";

import { Payload } from "@neworbit/redux-helpers";

import { ActionTaskSuccessPayload } from "../crud/ohCase/model";
import { parseTaskModel } from "../task/model";

import {
    COMPLETE_CREATE_VIDEO_CONSULTATION,
    COMPLETE_CREATE_VIDEO_CONSULTATION_SUCCESS,
    CREATE_TEAMS_MEETING,
    CREATE_TEAMS_MEETING_SUCCESS,
    UNABLE_TO_BOOK_VIDEO_APPOINTMENT,
    UNABLE_TO_BOOK_VIDEO_APPOINTMENT_SUCCESS
} from "./actionTypes";
import { videoMeetingsApi } from "./videoMeetingsApi";

export type VideoMeetingsAction =
    ({ type: typeof CREATE_TEAMS_MEETING_SUCCESS }) & Payload<ActionTaskSuccessPayload> |
    ({ type: typeof UNABLE_TO_BOOK_VIDEO_APPOINTMENT_SUCCESS }) & Payload<ActionTaskSuccessPayload> |
    ({ type: typeof COMPLETE_CREATE_VIDEO_CONSULTATION_SUCCESS }) & Payload<ActionTaskSuccessPayload>;

export const createVideoMeeting = (ohCaseId: string, taskId: string) => {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(
            dispatch,
            CREATE_TEAMS_MEETING,
            videoMeetingsApi.createVideoMeeting(ohCaseId, taskId)
        );
        const taskDto = parseTaskModel(result.videoAppointmentTaskDto);
        dispatch(createVideoMeetingSuccess({ ohCaseId, tasks: [taskDto] }));
    };
};

export const createVideoMeetingSuccess = (payload: ActionTaskSuccessPayload): VideoMeetingsAction => {
    return {
        type: CREATE_TEAMS_MEETING_SUCCESS,
        payload
    };
};

export const markVideoConsultationAsUnableToBook = (ohCaseId: string, taskId: string, justification: string) => {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(
            dispatch,
            UNABLE_TO_BOOK_VIDEO_APPOINTMENT,
            videoMeetingsApi.markVideoConsultationAsUnableBook(ohCaseId, taskId, justification)
        );
        const taskDtos = result.tasks.map(parseTaskModel);
        dispatch(markVideoConsultationAsUnableToBookSuccess({ ohCaseId, tasks: taskDtos }));
    };
};

export const markVideoConsultationAsUnableToBookSuccess = (payload: ActionTaskSuccessPayload): VideoMeetingsAction => {
    return {
        type: UNABLE_TO_BOOK_VIDEO_APPOINTMENT_SUCCESS,
        payload
    };
};

export const completeCreateVideoConsultation = (ohCaseId: string, taskId: string) => {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(
            dispatch,
            COMPLETE_CREATE_VIDEO_CONSULTATION,
            videoMeetingsApi.completeCreateVideoConsultation(ohCaseId, taskId)
        );
        const taskDto = parseTaskModel(result.completeCreateVideoConsultationTaskDto);
        dispatch(completeCreateVideoConsultationSuccess({ ohCaseId, tasks: [taskDto] }));
    };
};

export const completeCreateVideoConsultationSuccess = (payload: ActionTaskSuccessPayload): VideoMeetingsAction => {
    return {
        type: COMPLETE_CREATE_VIDEO_CONSULTATION_SUCCESS,
        payload
    };
};
